import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const MutualFundsInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section mutual-funds-fin">
                <h2 className="other-pages-title">Mutual Funds</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/mutual-funds-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Mutual Funds</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What are Mutual Funds?</h2>

                <p className="info-loan-description-smco">
                    Mutual funds are investment vehicles that pool money from multiple investors to invest in a diversified portfolio of stocks, bonds, and other securities. Managed by professional fund managers, mutual funds offer individuals access to a wide range of investment opportunities that might otherwise be difficult to achieve individually. They provide diversification, professional management, and liquidity, making them suitable for both novice and experienced investors.
                    <br /><br />
                    There are various types of mutual funds, including equity funds, debt funds, hybrid funds, and index funds. Each type caters to different risk profiles and investment goals. Equity funds invest primarily in stocks for long-term growth, while debt funds focus on fixed-income securities for stability and income generation.
                    <br /> <br />
                    Mutual funds offer several advantages, including diversification to reduce risk, professional management, liquidity through easy redemption, and affordability with low minimum investment requirements. However, they also carry market risks, and returns are not guaranteed. It's important to assess your risk tolerance, investment horizon, and financial goals before investing.
                    <br /><br />
                    Investing in mutual funds requires careful research and consideration. Understanding the fund's objectives, past performance, expense ratio, and risk factors is crucial. Consulting with financial advisors can help you choose the right mutual funds that align with your investment strategy.
                    <br />
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Diversification:</strong> Spread investments across various assets to reduce risk.</li>
                        <li><strong>Professional management:</strong> Expert fund managers make investment decisions.</li>
                        <li><strong>Liquidity:</strong> Easy to buy and sell units on any business day.</li>
                        <li><strong>Affordability:</strong> Low minimum investment amounts.</li>
                        <li><strong>Transparency:</strong> Regular disclosure of portfolio holdings and performance.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Mutual Funds</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Equity Funds:</strong> Invest in stocks for long-term capital growth.</li>
                        <li><strong>Debt Funds:</strong> Invest in bonds and fixed-income securities for stability.</li>
                        <li><strong>Hybrid Funds:</strong> Combine equity and debt for balanced risk-return.</li>
                        <li><strong>Index Funds:</strong> Track market indices for passive investment.</li>
                        <li><strong>ELSS:</strong> Equity-linked savings schemes with tax benefits.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Risk diversification:</strong> Reduces the impact of individual stock volatility.</li>
                        <li><strong>Expert management:</strong> Professional oversight of investments.</li>
                        <li><strong>Tax advantages:</strong> Certain funds offer tax benefits under Section 80C.</li>
                        <li><strong>Convenience:</strong> Easy online investing and tracking.</li>
                        <li><strong>Scalability:</strong> Suitable for various investment amounts and goals.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default MutualFundsInfo;
